import { Controller } from '@hotwired/stimulus'
import TomSelect from 'tom-select'

export default class extends Controller {
  static values = {
    clear: Boolean,
    max: Number,
    url: String,
    maxItems: { type: Number, default: 1000 },
    maxOptions: { type: Number, default: 100 }
  }

  initialize() {
    this._onBeforeMorphElement = this._onBeforeMorphElement.bind(this)
    this._onMorphElement = this._onMorphElement.bind(this)
  }

  connect() {
    this._tommify()
    this.element.addEventListener('turbo:before-morph-element', this._onBeforeMorphElement)
    this.element.addEventListener('turbo:morph-element', this._onMorphElement)
  }

  disconnect() {
    this.element.removeEventListener('turbo:before-morph-element', this._onBeforeMorphElement)
    this.element.removeEventListener('turbo:morph-element', this._onMorphElement)

    if (this.element.tomselect) {
      this._cleanup(this.element)
    }
  }

  get options() {
    let options = {
      plugins: ['change_listener']
    }

    if (this.clearValue) {
      options.plugins.push("clear_button")
    }

    if (this.maxOptionsValue) {
      options.maxOptions = this.maxOptionsValue
    }

    if (this.element.multiple) {
      if (this.maxItemsValue) {
        options.maxItems = this.maxItemsValue
      }
      options.plugins.push("remove_button")

      options.onItemAdd = function () {
        this.setTextboxValue('')
        this.refreshOptions()
      }

    } else {
      options.plugins.push("dropdown_input")
    }

    if (this.hasUrlValue) {
      options.load = this.load.bind(this)
      const toElement = (html) => { const d = document.createElement('div'); d.innerHTML = html; return d.firstElementChild }
      const fallback = (item, escape) => `<div>${escape(item.text ?? item.value)}</div>`
      options.render = {
        option: (item, escape) => item.html ? toElement(item.html) : fallback(item, escape),
        item: (item, escape) => item.html ? toElement(item.html) : fallback(item, escape),
      }
    }

    return options
  }

  load(query, callback) {
    fetch(this.urlValue + '?q=' + encodeURIComponent(query))
      .then(response => response.json())
      .then(json => { callback(json.results) })
      .catch(() => { callback() })
  }

  _onBeforeMorphElement(event) {
    if (event.target.tomselect) {
      this._cleanup(event.target)
    }
  }

  _onMorphElement(event) {
    // Stupid TomSelect
    setTimeout(() => {
      if (!event.target.tomselect) {
        new TomSelect(event.target, this.options)
      }
    }, 100)
  }

  _cleanup(element) {
    // See https://stackoverflow.com/a/72844779
    const currentValue = element.value
    element.tomselect.clearCache()
    element.tomselect.destroy()
    element.value = currentValue
  }

  _tommify() {
    if (!this.element.tomselect) {
      new TomSelect(this.element, this.options)
    }
  }
}